import { Box } from "@mui/material";

export const EmailFooterPreview = (props) => {
    const { htmlContent } = props;

    return (
        <Box
            sx={{
                border: 1,
                borderColor: "divider",
                borderRadius: 1,
                p: 2,
                bgcolor: "background.default",
            }}
        >
            <iframe
                srcDoc={htmlContent}
                title="Footer Preview"
                style={{
                    width: "100%",
                    minHeight: "150px",
                    border: "none",
                }}
                sandbox=""
            />
        </Box>
    );
};
